import Typography from "component-lib/Base/components/Typography"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import NextImageWrapper from "../../../SSR/NextImageWrapper"
import { Link } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const WmContentCard = ({
  cardList,
  nextImageloadingStrategy,
  nextImagePriority,
}) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width

  let hTag = "h3"
  // prevent layout shift in SSR since bodywidth is always 0 on the server
  if (!bodyWidth) {
    hTag = "h4"
  } else if (bodyWidth) {
    hTag = bodyWidth < 1025 ? "h4" : "h3"
  }

  return (
    <div
      data-testid="WmContentCard"
      className={`cardWrapper  ${cardList.cardImage ? "contentcard" : ""}`}
    >
      {cardList.cardImage ? (
        <NextImageWrapper
          className="pb-4 contentcardimage"
          src={getContentUrl(cardList.cardImage)}
          alt={cardList.imageAltText}
          nextImageProps={{
            height: 358.86,
            width: 215,
            loading: nextImageloadingStrategy,
            priority: nextImagePriority,
          }}
          renderLegacyComponent={(props) => <img {...props} />}
        />
      ) : (
        ""
      )}
      <div
        className={`${
          cardList.cardImage
            ? "WmcontentcardwithImage"
            : "WmcontentcardwithoutImage"
        }`}
      >
        <div
          className="maax-font-weight-bold cardItemtitle"
          data-testid="WmContentCard-cardEyebrowText"
        >
          {cardList.cardEyebrowText}
        </div>

        <Typography
          className="cardHeading maax-font-weight-bold"
          variant={hTag}
          style={{ color: "black" }}
          data-testid="WmContentCard-cardHeading"
          paragraph
          role="heading"
          aria-level={hTag === "h3" ? 3 : 4}
        >
          {cardList.cardHeading}
        </Typography>
        <div
          className="flex-grow-1 cardItemsubText maax-font-weight-regular"
          data-testid="WmContentCard-cardBody"
        >
          {cardList.cardBody}
        </div>
        {cardList.cardCtaText && (
          <Link
            overrideClass="maax-font-weight-regular"
            href={cardList.cardCtaURL}
            isExternalLink={cardList.externalLink}
            analytics_key={
              cardList?.analyticsKey ||
              `${cardList.cardHeading} ${cardList.cardCtaText} ${cardList.cardCtaURL}`
            }
          >
            {cardList.cardCtaText}
          </Link>
        )}
      </div>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// WmContentCard.propTypes = {
//   cardList: PropTypes.object.isRequired,
//   nextImageloadingStrategy: PropTypes.string.isRequired,
//   nextImagePriority: PropTypes.bool.isRequired,
// }

export default WmContentCard
